'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00246 from "./presto.-Danger-Alert$$anon$6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00247 from "./presto.-Danger-Alert$$anon$7.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$5() {
  this.aIn = null;
  this.aIl = null;
  this.aIm = false;
  this.aIj = null;
  this.aIk = false;
  this.aIo = false;
  this.aIp = false;
  this.aIn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$5 as $c_Lpresto_DangerAlert$$anon$5 };
$p = $c_Lpresto_DangerAlert$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$5;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$5() {
}
export { $h_Lpresto_DangerAlert$$anon$5 as $h_Lpresto_DangerAlert$$anon$5 };
$h_Lpresto_DangerAlert$$anon$5.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aIn;
});
$p.t = (function() {
  if ((!this.aIm)) {
    this.aIl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("plans", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aIm = true;
  }
  return this.aIl;
});
$p.ae = (function() {
  if ((!this.aIk)) {
    this.aIj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00246.$c_Lpresto_DangerAlert$$anon$6()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00247.$c_Lpresto_DangerAlert$$anon$7()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aIk = true;
  }
  return this.aIj;
});
$p.w = (function() {
  if ((!this.aIp)) {
    this.aIo = false;
    this.aIp = true;
  }
  return this.aIo;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$5, "presto.DangerAlert$$anon$5", ({
  Gj: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$5 as $d_Lpresto_DangerAlert$$anon$5 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$5.js.map
